<template>
  <div>
    <WmsTable v-bind="$attrs" :columns="newColumns" :is-row-selection="tableType == '待处理'"
      @selectChange="selectChangeCall" @pageChange="pageChangeCall" :dataSource="dataSource" ref="wmsTable"
      :isPagination="query" :hasHeader="false">

      <template slot="productImg" slot-scope="{ text, record, index }">
        <ImgView :src="text" v-if="text"></ImgView>
      </template>
      <div slot="action" style="display: flex;flex-wrap: wrap;" slot-scope="{ text, record, index }">
        <el-button type="text" @click="getDetail(record)">详情</el-button>
        <el-button type="text" @click="print(record)" v-if="tableType == '处理中' || tableType == '已完成'"
          :disabled="!record.newPkgCode">打印</el-button>
      </div>
    </WmsTable>

    <el-dialog title="详情" :visible.sync="dialogVisible">
      <WmsTable :columns="detailColums" :dataSource="detailData" ref="wmsTable" :isPagination="false"
        :hasHeader="false">
      </WmsTable>
    </el-dialog>
  </div>
</template>

<script>
import WmsTable from "@/components/WmsTable";
import ImgView from "@/components/ImgView";
import { columns, detailColums } from "@/views/abnormal/regularization/components/InterListData";
import { regularizationCreateTask, regularizationDetail, regularizationPrint } from "@/apis/abnormal";


export default {
  name: "InterList",
  components: {
    WmsTable,
    ImgView
  },
  props: {
    total: {
      type: String | Number,
    },
    dataSource: {
      type: Array,
      default: (_) => {
        return [];
      },
    },
    tableType: {
      type: String
    }
  },
  data() {
    return {
      columns,
      detailColums,
      selRow: [],
      targetLeft: 0,
      query: {
        current: 1,
        pageSize: 20,
        total: 0
      },
      dialogVisible: false,
      detailData: []
    };
  },
  watch: {
    total: {
      immediate: true,
      handler: function (newVal, oldVal) {
        this.query.total = newVal
      },
      immediate: true,
      keep: true,
    },
    //国际发货单居然 没有ID 
    dataSource: {
      immediate: true,
      handler: function (newVal, oldVal) {
        newVal.forEach(item => {
        })
      },
      immediate: true,
      keep: true,
    },
  },
  computed: {
    newColumns: function () {
      let _columns = [...columns];
      return _columns;
    },
  },
  methods: {
    pageChangeCall: function (payload) {
      this.query.current = payload.current
      this.query.pageSize = payload.pageSize
      this.$emit("pageChange", payload);
    },
    selectChangeCall: function (rows) {
      this.selRow = rows
      console.log('interlist', this.selRow)
      this.$emit("selectChange", rows);
    },
    resetPage() {
      this.query.current = 1
      this.$refs.wmsTable.resetSel()
    },
    getDetail(record) {
      console.log(record)
      let params = {
        regularizationCode: record.regularizationCode
      }
      regularizationDetail(params).then(res => {
        this.detailData = res.data
        this.dialogVisible = true
      })
    },
    print(record) {
      if (record.state == 2) {
        regularizationPrint({ newPkgCode: record?.newPkgCode }).then(res => {
          if (res.code == 0) {
            this.$emit("refeash");
            this.$wmsPrint.print().templatePrintByPkg([{...record,pkgCode:record.newPkgCode}])
          }
        })
      } else {
        this.$wmsPrint.print().templatePrintByPkg([{...record,pkgCode:record.newPkgCode}])
      }
    }
  },
};
</script>

<style scoped>
.ant-table-expanded-row .son__table--customize>>>td,
.son__table--customize>>>th {
  border-right: 0px solid #e8e8e8 !important;
}
</style>
